<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#a63232">
      <v-icon>
        {{ getApplicationActionIcon("reject") }}
      </v-icon>
      Reject Application(s)
    </SecondaryButton>
    <RejectCandidates
      v-if="isOpen"
      :isOpen="isOpen"
      @close="closeDialog"
      :applications="applications"
    />
  </BaseAction>
</template>

<script>
import RejectCandidates from "@/views/bookings/JobCandidate/components/RejectCandidates";
import BaseAction from "@/components/common/BaseAction";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import { getApplicationActionIcon } from "@/utils/bookings";

export default {
  name: "RejectCandidatesAction",
  components: {
    BaseAction,
    RejectCandidates,
    SecondaryButton
  },
  props: {
    applications: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog({ success }) {
      this.isOpen = false;
      if (success) {
        this.$emit("statusChanged");
      }
    },
    getApplicationActionIcon
  }
};
</script>
